
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IFormMetadata, ISearchableGridFormMetadata, TreeNode, Tuple } from "@tylertech/tyler-api-types";

/**
 * ReportFormService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ReportFormService {
    private readonly $apiService = inject(ApiService);
    
    AllViewPaths(): Promise<TreeNode[]> {
        return this.$apiService.sendAuth("IReportFormService/AllViewPaths");
    }
    AllViewPathsString(): Promise<string[]> {
        return this.$apiService.sendAuth("IReportFormService/AllViewPathsString");
    }
    AllViewPathsStringByApp(): Promise<{ [key: string]: string[] }> {
        return this.$apiService.sendAuth("IReportFormService/AllViewPathsStringByApp");
    }
    Get(filterString?: string): Promise<IFormMetadata[]> {
        return this.$apiService.sendAuth("IReportFormService/Get", null, filterString);
    }
    GetByType(type: string, filterString?: string): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IReportFormService/GetByType", type, filterString);
    }
    GetEditForm(pathAndType: Tuple<string, string>): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IReportFormService/GetEditForm", pathAndType);
    }
    GetForm(path: string, filterString?: string): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IReportFormService/GetForm", path, filterString);
    }
    GetFormAssembly(formPath: string): Promise<string> {
        return this.$apiService.sendAuth("IReportFormService/GetFormAssembly", formPath);
    }
    GetPaths(filterString?: string): Promise<TreeNode[]> {
        return this.$apiService.sendAuth("IReportFormService/GetPaths", null, filterString);
    }
    GetSearchableGridScreens(filterString?: string): Promise<ISearchableGridFormMetadata[]> {
        return this.$apiService.sendAuth("IReportFormService/GetSearchableGridScreens", null, filterString);
    }
}
